<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="12"
        lg="12"
        class="pb-0"
      >
        <v-text-field
          v-model="ticket.ntdSerialNumber"
          label="NTD Serial number	"
          placeholder=" "
          outlined
          dense
          :readonly="false"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="12"
        lg="12"
        class="pb-0"
      >
        <v-text-field
          v-model="ticket.cpeName"
          label="What CPE is connected?"
          placeholder=" "
          outlined
          dense
          :readonly="false"
        ></v-text-field>
      </v-col>

      <v-col
        cols="12"
        md="12"
        lg="12"
        class="pb-0"
      >
        <v-text-field
          v-model="ticket.cpeMac"
          label="What is the CPE MAC address?	"
          placeholder=" "
          outlined
          dense
          :readonly="false"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="12"
        lg="12"
        class="pb-0"
      >
        <v-radio-group
          row
          v-model="ticket.fibreDamaged"
        >
          <label class="mr-2">Is fibre lead damaged?</label>
          <v-radio label="Yes" value="Yes"></v-radio>
          <v-radio label="No" value="No"></v-radio>
        </v-radio-group>
      </v-col>

      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Power Status"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="PowerStatus"
            label="Power Status"
            name="Power Status"
            outlined
            placeholder="Please select Power Status"
            v-model="ticket.powerStatus"
          ></v-select>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Power Behaviour"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="BehaviorOptions"
            label="Power Behaviour"
            name="Power Behaviour"
            outlined
            placeholder="Please select Power Behaviour"
            v-model="ticket.powerBehaviour"
          ></v-select>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Optical Status"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="OpticalStatus"
            label="Optical Status"
            name="Optical Status"
            outlined
            placeholder="Please select Optical Status"
            v-model="ticket.opticalStatus"
          ></v-select>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Optical Behaviour"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="BehaviorOptions"
            label="Optical Behaviour"
            name="Optical Behaviour"
            outlined
            placeholder="Please select Optical Behaviour"
            v-model="ticket.opticalBehaviour"
          ></v-select>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Alarm Status"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="AlarmStatus"
            label="Alarm Status"
            name="Alarm Status"
            outlined
            placeholder="Please select Alarm Status"
            v-model="ticket.alarmStatus"
          ></v-select>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Alarm Behaviour"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="BehaviorOptions"
            label="Alarm Behaviour"
            name="Alarm Behaviour"
            outlined
            placeholder="Please select Alarm Behaviour"
            v-model="ticket.alarmBehaviour"
          ></v-select>
        </ValidationProvider>
      </v-col>


      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="UNI-D Status"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="UNIDStatus"
            label="UNI-D Status"
            name="UNI-D Status"
            outlined
            placeholder="Please select UNI-D Status"
            v-model="ticket.unidStatus"
          ></v-select>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="UNI-D Behaviour"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="BehaviorOptions"
            label="UNI-D Behaviour"
            name="UNI-D Behaviour"
            outlined
            placeholder="Please select UNI-D Behaviour"
            v-model="ticket.unidBehaviour"
          ></v-select>
        </ValidationProvider>
      </v-col>


      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="UNI-V Status"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="UNIVStatus"
            label="UNI-V Status"
            name="UNI-V Status"
            outlined
            placeholder="Please select UNI-V Status"
            v-model="ticket.univStatus"
          ></v-select>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="UNI-V Behaviour"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="BehaviorOptions"
            label="UNI-V Behaviour"
            name="UNI-V Behaviour"
            outlined
            placeholder="Please select UNI-V Behaviour"
            v-model="ticket.univBehaviour"
          ></v-select>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Update Status"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="UpdateStatus"
            label="Update Status"
            name="Update Status"
            outlined
            placeholder="Please select Update Status"
            v-model="ticket.updateStatus"
          ></v-select>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Update Behaviour"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="BehaviorOptions"
            label="Update Behaviour"
            name="Update Behaviour"
            outlined
            placeholder="Please select Update Behaviour"
            v-model="ticket.updateBehaviour"
          ></v-select>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Used Port"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="UsedPort"
            label="Used Port"
            name="Used Port"
            outlined
            placeholder="Please select Used Port"
            v-model="ticket.usedPort"
            onchange=""
          ></v-select>
        </ValidationProvider>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "nbn-check-list-details-fibre",
  props: {
    ticket: { type: Object },
  },
  data: () => ({
    PowerStatus: [
      {text: "Green", value: "Green", disabled: false},
      {text: "Red", value: "Red", disabled: false},
      {text: "Off", value: "Off", disabled: false},
    ],
    OpticalStatus: [
      {text: "Green", value: "Green", disabled: false},
      {text: "Red", value: "Red", disabled: false},
      {text: "Off", value: "Off", disabled: false},
    ],
    AlarmStatus: [
      {text: "Green", value: "Green", disabled: false},
      {text: "Red", value: "Red", disabled: false},
      {text: "Off", value: "Off", disabled: false},
    ],
    UNIDStatus: [
      {text: "Amber", value: "Amber", disabled: false},
      {text: "Off", value: "Off", disabled: false},
    ],
    UNIVStatus: [
      {text: "Green", value: "Green", disabled: false},
      {text: "Off", value: "Off", disabled: false},
    ],
    UpdateStatus: [
      {text: "Green", value: "Green", disabled: false},
      {text: "Red", value: "Red", disabled: false},
      {text: "Off", value: "Off", disabled: false},
    ],
    BehaviorOptions: [
      {text: "Flashing", value: "Flashing", disabled: false},
      {text: "Solid", value: "Solid", disabled: false},
    ],
    UsedPort: [
      {text: "D1", value: "D1", disabled: false},
      {text: "D2", value: "D2", disabled: false},
      {text: "D3", value: "D3", disabled: false},
      {text: "D4", value: "D4", disabled: false},
      {text: "V1", value: "V1", disabled: false},
      {text: "V2", value: "V2", disabled: false},
    ],
  })
}
</script>

<style scoped>

</style>
